// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3FQin","list":"styles_list__21-ta"};